import { render, staticRenderFns } from "./CatalogItemUsage.vue?vue&type=template&id=7d63e28c&scoped=true&"
import script from "./CatalogItemUsage.vue?vue&type=script&lang=js&"
export * from "./CatalogItemUsage.vue?vue&type=script&lang=js&"
import style0 from "./CatalogItemUsage.vue?vue&type=style&index=0&id=7d63e28c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d63e28c",
  null
  
)

export default component.exports